'use strict';

angular.module('atex.art').factory('ArtInboxOptions',
    [
      function() {
        var shouldShowInInbox = function(obj) {
          if ( typeof obj === 'undefined' ) {
            return false;
          }

          var artInboxAspect = atex.onecms.ObjectUtils.getByPath(obj, 'data/aspects/art.Inbox/data');

          return ( ( typeof artInboxAspect === 'undefined' ) || ( artInboxAspect.showInInbox === true ) );
        };

        return {
          shouldShowInInbox: shouldShowInInbox
        };
      }
    ]);
